import type {ViewerFields_UserFragment} from '../generated/graphql';
import {userInfoRecord} from './userInfo';

/**
 * Whether the viewer still has to go through onboarding, from the two signals
 * the app checks in `frontends/app/src/App.tsx`:
 *
 * `signupRequired` is gorilla's "this user has no username yet" (see
 * `UserResolver.SignupRequired` in services/gorilla/api/resolver/user.go). It
 * is not the whole answer on its own: a migrated user with no personal entity
 * has a username and still may not have finished the flow.
 *
 * `userInfo.isOnboardingIncomplete` covers that case. The flow's account step
 * sets it and its final `complete()` clears it, so a user who leaves partway
 * keeps the flag and is sent back here on their next login until they finish.
 */
export const needsOnboarding = (viewer: ViewerFields_UserFragment): boolean =>
  viewer.signupRequired ||
  userInfoRecord(viewer.userInfo).isOnboardingIncomplete === true;
